import { ArrowRightOutlined } from '@ant-design/icons';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { SubmissionStateTag } from '@framework/frontoffice-submission/submission/state/SubmissionStateTag.tsx';
import { LinkButton } from '@framework/ui/components/button/LinkButton.tsx';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { generatePath } from '@framework/ui/core/router/TypedRoute.tsx';
import { Flex, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';

const { Text, Title } = Typography;

const LabelTextSecondary = styled(Text)`
  &&& {
    color: ${props => props.theme.colorTextSecondary};
  }
`;

const IntegrationRowWrapper = styled.div`
  border-top: 1px solid ${props => props.theme.colorSplit};
  padding: 8px 0;
  &:last-child {
    border-bottom: 1px solid ${props => props.theme.colorSplit};
  }
`;

export interface IIntegrationRowProps {
  submission?: RichiestaDTO | undefined;
  isCurrent?: boolean;
}

/**
 * Tab delle comunicazioni post invio di una richiesta richiesta.
 */
export function IntegrationRow(props: IIntegrationRowProps) {
  const { submission, isCurrent } = props;
  const { t } = useTranslation();
  const isTablet = useBreakpoint(down('md'));
  const isMobile = useBreakpoint(down('sm'));
  if (!submission) return null;

  return (
    <IntegrationRowWrapper>
      <FlexRow
        responsive
        left={
          <div style={{ width: isMobile ? '100%' : isTablet ? 130 : 200 }}>
            <Space wrap size={[8, 0]}>
              <LabelTextSecondary>
                {t('integration.stato', 'Stato:')}
              </LabelTextSecondary>
              <SubmissionStateTag submission={submission} />
            </Space>
          </div>
        }
        right={
          !isCurrent && (
            <LinkButton
              to={generatePath('/richieste/:id', {
                id: submission?.id ?? '',
              })}
            >
              {t('integration.vai-alla-richiesta', 'Vai alla richiesta')}{' '}
              <ArrowRightOutlined />
            </LinkButton>
          )
        }
      >
        <Flex vertical>
          {submission.dataInvio ? (
            <Space wrap size={[8, 0]}>
              <LabelTextSecondary>
                {t('integration.data-invio', 'Data Invio:')}
              </LabelTextSecondary>
              <ISODate date={submission?.dataInvio} format="DD/MM/YYYY HH:mm" />
            </Space>
          ) : (
            <Space wrap size={[8, 0]}>
              <LabelTextSecondary>
                {t('integration.data-creazione', 'Data Creazione:')}
              </LabelTextSecondary>
              <ISODate
                date={submission?.dataCreazione}
                format="DD/MM/YYYY HH:mm"
              />
            </Space>
          )}

          {submission?.numeroProtocollo && (
            <Space wrap size={[8, 0]}>
              <LabelTextSecondary>Numero Protocollo:</LabelTextSecondary>
              <Text strong>{submission?.numeroProtocollo}</Text>
            </Space>
          )}
          {submission?.dataProtocollo && (
            <Space wrap size={[8, 0]}>
              <LabelTextSecondary>Data Protocollo:</LabelTextSecondary>
              <Text strong>
                <ISODate
                  date={submission?.dataProtocollo}
                  format="DD/MM/YYYY"
                />
              </Text>
            </Space>
          )}
        </Flex>
      </FlexRow>
    </IntegrationRowWrapper>
  );
}
